<ion-button [ngClass]="class" [color]="color" size="small" [expand]="expand" [disabled]="disabled" [routerDirection]="routerDirection">
  <ion-icon [name]="icon" *ngIf="icon" [slot]="iconSlot"></ion-icon>
  {{ label }}
</ion-button>
